import { render } from "./AlignedTokensView.vue?vue&type=template&id=62eee213&scoped=true"
import script from "./AlignedTokensView.vue?vue&type=script&lang=js"
export * from "./AlignedTokensView.vue?vue&type=script&lang=js"

import "./AlignedTokensView.vue?vue&type=style&index=0&id=62eee213&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62eee213"]])

export default __exports__